import React from "react";

import { A11y } from "@churchofjesuschrist/eden-buttons";
import {
  GearOutline,
  Notifications,
  NotificationsUnread,
} from "@churchofjesuschrist/eden-icons";
import {
  accentColorPrimary as blue,
  green40 as green,
  textColorSecondary as grey,
  red40 as red,
  backgroundColorLevelCurrent,
  accentColorLinkVisited as purple,
} from "@churchofjesuschrist/eden-style-constants";
import {WorkforceHeader, MenuButton} from "@churchofjesuschrist/eden-workforce-header";
import styled from "styled-components";

import BannerAlertsManager from "../../alerts/banner-alerts-manager/banner-alerts-manager";
import CounterIcon from "../../generic/counter-icon/counter-icon";
import TopBarUserMenu from "../top-bar-user-menu/top-bar-user-menu";

const HomeLink = styled(A11y)`
  color: #fff !important;
  font-weight: bold;
  padding: 0;
  margin: -10px 0 0 0;
`;
const AlertsAndAdmin = styled.div`
  display: flex;
  width: ${(props) => (props.$wide ? "110px" : "55px")};
`;
const IconLinkHolder = styled(A11y)`
  flex: 1;
  align-self: right;
  color: ${backgroundColorLevelCurrent};
  a {
    color: ${backgroundColorLevelCurrent};
    cursor: pointer;
    &:hover {
      color: ${backgroundColorLevelCurrent};
    }
  }
`;
//leave this here just because it is an easy/cheap way to get rid of an es-lint warning :)
const IconLink = styled.a``;
const SystemAlertsHolder = styled.div`
  /*position: relative;*/
`;
const AbsoluteBanners = styled.div`
  position: absolute;
  max-width: 1000px;
  z-index: 101;
  top: 0;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
`;
const StyledWorkforceHeader = styled(WorkforceHeader)`
  background-color: ${(props) => props.color};
`;

//NOTE: the proper thing to do would really be to
//give this component
const TopBar = ({
  user,
  children = () => {},
  theme,
  hamburgerClick,
  startOpen,
  lean = false,
  alerts = { systemAlerts: [] },
  onUserAlertDeleted = () => {},
  onHomeClicked = () => {},
  onAdminClicked = () => {},
  onUserAlertClicked = () => {},
  canAdmin = false,
  menuOpen = true,
}) => {
  let color = lean ? grey : red;
  switch (theme) {
  case "institute":
    color = blue;
    break;
  case "seminary":
    color = green;
    break;
  case "area":
    color = red;
    break;
  case "sis":
    color = purple;
    break;
  default:
    color = grey;
    break;
  }

  const alertsCount = alerts.systemAlerts.length; //todo: as actionables come in add those lengths here as well
  //TODO: take the alerts this user has and make an alertCounter icon component
  //TODO: link to user alerts once we have that screen
  const onAlertsChanged = (change) => {
    if (change && change.action === "delete") {
      onUserAlertDeleted(change.alert);
    }
  };
  const menuProp = lean ? {} : {menuButton: <MenuButton onClick={hamburgerClick} />}
  return (
    <>
      <StyledWorkforceHeader
        color={color}
        data-id="site-header"
        {...menuProp}
        tools={
          <>
            <AlertsAndAdmin $wide={canAdmin}>
              {canAdmin ? (
                <IconLinkHolder onClick={onAdminClicked}>
                  <IconLink>
                    <CounterIcon count={0} alwaysShowCount={false}>
                      <GearOutline />
                    </CounterIcon>
                  </IconLink>
                </IconLinkHolder>
              ) : undefined}
              <IconLinkHolder
                onClick={onUserAlertClicked}
                data-id="header-alerts-link"
              >
                <CounterIcon count={alertsCount} alwaysShowCount={false}>
                  {alertsCount > 0 ? (
                    <NotificationsUnread />
                  ) : (
                    <Notifications />
                  )}
                </CounterIcon>
              </IconLinkHolder>
            </AlertsAndAdmin>
            <TopBarUserMenu user={user} startOpen={startOpen}>
              {children}
            </TopBarUserMenu>
          </>
        }
        name={<HomeLink onClick={onHomeClicked} data-id="header-home-link">
        WISE
        </HomeLink>}
      />

      <SystemAlertsHolder>
        <AbsoluteBanners>
          <BannerAlertsManager
            onRemoveAlert={onAlertsChanged}
            alerts={alerts.systemAlerts}
          />
        </AbsoluteBanners>
      </SystemAlertsHolder>
    </>
  );
}
export default TopBar;
